import React from 'react';
import styled from 'styled-components';
import { useCloudSecurity } from '../context/CloudSecurityContext';
import { getAllFrameworks } from '../data/frameworkMappings';

const Container = styled.div`
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
`;

const FilterLabel = styled.div`
  font-size: 1.1em;
  margin-bottom: 10px;
  text-align: center;
  width: 100%;
`;

const FrameworkButton = styled.button`
  padding: 8px 16px;
  background: ${props => props.active ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'rgba(102, 126, 234, 0.1)'};
  color: ${props => props.active ? 'white' : '#667eea'};
  border: 1px solid ${props => props.active ? 'transparent' : 'rgba(102, 126, 234, 0.3)'};
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9em;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 3px 10px rgba(102, 126, 234, 0.2);
  }
`;

const FrameworkFilter = () => {
  const { selectedFramework, setSelectedFramework } = useCloudSecurity();
  
  // Get all available frameworks and add "All" option
  const frameworks = ['All', ...getAllFrameworks()];
  
  return (
    <Container>
      <FilterLabel>Filter by compliance framework:</FilterLabel>
      {frameworks.map(framework => (
        <FrameworkButton
          key={framework}
          active={selectedFramework === framework}
          onClick={() => setSelectedFramework(framework)}
        >
          {framework}
        </FrameworkButton>
      ))}
    </Container>
  );
};

export default FrameworkFilter; 